import ApiClient from '@/api-client';

export default {
    namespaced: true,
    state: {
        costSheet: {},
        costSheetGroups: [],
    },
    mutations: {
        setCostSheet(state, costSheet) {
            state.costSheet = costSheet;
        },
        setCostSheetGroups(state, costSheetGroups) {
            state.costSheetGroups = costSheetGroups;
        },
    },
    actions: {
        async getCostSheet({ commit, state }, costSheetId) {
            const costSheet = await ApiClient.getItem(`/api/cost-sheets/${costSheetId || state.costSheet.id}?append=summary&include=engineer,proposal,proposalLocation`);
            commit('setCostSheet', costSheet);
        },
        async getCostSheetGroups({ commit, state }, costSheetId) {
            const costSheetGroups = await ApiClient.getCollection(`/api/cost-sheets/${costSheetId || state.costSheet.id}/cost-sheet-groups`);
            commit('setCostSheetGroups', costSheetGroups);
        },
        reset({ commit }) {
            commit('setCostSheet', {});
            commit('setCostSheetGroups', {});
        },
    },
};
